// Portal navigation derived from the Brugo operational domain structure.
// Grouped for a calmer sidebar; every existing section is kept (same keys + paths).
export const NAV_GROUPS = [
  { label: "Overview", items: [
    { key: "dashboard", label: "Control Centre", icon: "LayoutDashboard", path: "/" },
    { key: "notifications", label: "Notifications", icon: "Bell", path: "/notifications" },
    { key: "activity", label: "Activity & Changes", icon: "Activity", path: "/activity" },
  ] },
  { label: "Operations", items: [
    { key: "requests", label: "Requests & Leads", icon: "Send", path: "/requests" },
    { key: "projects", label: "Projects & Milestones", icon: "FolderKanban", path: "/projects" },
    { key: "visits", label: "Site Visits", icon: "ClipboardCheck", path: "/visits" },
    { key: "promise", label: "Brugo Promise", icon: "ShieldCheck", path: "/promise" },
    { key: "care", label: "Customer Care", icon: "Headset", path: "/care" },
    { key: "orders", label: "Orders & Delivery", icon: "Package", path: "/orders" },
  ] },
  { label: "People", items: [
    { key: "customers", label: "Customers", icon: "Users", path: "/customers" },
    { key: "professionals", label: "Professionals & Field", icon: "Briefcase", path: "/professionals" },
    { key: "performance", label: "Performance", icon: "TrendingUp", path: "/performance" },
    { key: "incentives", label: "Incentives & Clusters", icon: "Award", path: "/incentives" },
  ] },
  { label: "Money", items: [
    { key: "payments", label: "Payments & Wallets", icon: "CreditCard", path: "/payments" },
    { key: "coupons", label: "Coupons & Offers", icon: "TicketPercent", path: "/coupons" },
    { key: "invoices", label: "Invoices & GST", icon: "FileText", path: "/invoices" },
  ] },
  { label: "Setup & content", items: [
    { key: "catalog", label: "Catalog & Services", icon: "Layers", path: "/catalog" },
    { key: "content", label: "Customer CMS", icon: "Image", path: "/content" },
  ] },
  { label: "System", items: [
    { key: "system", label: "System Control", icon: "Power", path: "/system" },
    { key: "data", label: "Data Explorer", icon: "Database", path: "/data" },
    { key: "deployments", label: "Deployments & Health", icon: "ServerCog", path: "/deployments" },
    { key: "openitems", label: "Open Items", icon: "ListChecks", path: "/open-items" },
    { key: "analytics", label: "Analytics & Audit", icon: "BarChart3", path: "/analytics" },
  ] },
];

export const NAV = NAV_GROUPS.flatMap((g) => g.items);
